import { pawnshop_reports_reader_service } from "../../../api/restclient";
import axios from "axios";

import moment from "moment";

export const makeRequest = async (endpoint, params, method = "get") => {
  try {
    const response =
      method === "get"
        ? await pawnshop_reports_reader_service.get(endpoint, params)
        : await pawnshop_reports_reader_service.post(endpoint, params);
    return response;
  } catch {
    return Promise.resolve();
  }
};

export const makeConcurrentRequest = async (requestData, method = "get") => {
  const requests = requestData.map((data) => {
    const { endpoint, params } = data;
    return method === "get"
      ? pawnshop_reports_reader_service.get(endpoint, params)
      : pawnshop_reports_reader_service.post(endpoint, params);
  });

  try {
    const response = await axios.all(requests);
    return response;
  } catch {
    return Promise.resolve();
  }
};

export const constructUrlParams = (data) => {
  const urlParams = new URLSearchParams();
  urlParams.append("from", data.dates.from);
  urlParams.append("to", data.dates.to);
  return urlParams;
};

export const formatDateParam = (date) => moment(date).format("YYYY-MM-DD");
